import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../shared/auth.service';
import { SessionService } from '../shared/services';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private _authService: AuthService,
    private _sessionService: SessionService,
    private _router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (!this._authService.isLoggedIn() || !this._sessionService.getWorkingContainer()) {
      this._router.navigate(['login'], { queryParams: route.queryParams });
      return false;
    }
    if (!this._authService.isEulaAccepted()) {
      this._router.navigate(['eula']);
      return false;
    }
    return true;
  }
}
